function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("style", {
  type: "text/css"
}, "\n\t.vd0{fill:url(#SVGID_5_);}\n\t.vd1{fill:url(#SVGID_6_);}\n\t.vd2{fill:#ECF4F8;}\n\t.vd3{font-family=\"Gotham-Bold, Gotham\";}\n\t.vd4{font-size:25px;}\n\t.vd5{font-size:37px;}\n");

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  className: "vd0",
  d: "M789.8,982.7c0.2-0.2,0.4-0.3,0.8-0.6c0.3-0.2,0.4-0.3,0.6-0.4c0.5-0.4,0.8-0.6,1.1-0.8 c4.6-3.1,8.9-6.7,12.8-10.7c9.8-10.2,16-23.3,17.9-37.4c1.3-9.7,1.1-19.5-0.4-29.2c-1.6-10.3-4.2-20.4-7.7-30.1 c-3.6-10.2-7.8-20.2-12.6-30c-3.7-7.6-7.8-15.3-12.4-23.6c0-0.1-0.1-0.2-0.3-0.5c-0.1-0.3-0.2-0.4-0.3-0.6l-0.1-0.3l-1.9-3.2 l-0.1-0.2c-0.1-0.1-0.2-0.2-0.3-0.4l-0.1-0.2c-0.9-1.5-1.6-2.7-3.3-5.4c-3.8-6.2-5.5-8.9-7.7-12.3c-3.6-5.6-7.6-11.4-12.2-17.4 c-5.3-7.1-11-14-17.1-20.5c-7.5-8.1-15.9-15.2-25-21.4c-7.7-5.2-16.2-9.1-25.1-11.5c-12.5-3.3-25.6-2.9-37.8,1.2 c-4.2,1.3-8.3,3.1-12.2,5.2c-0.1,0.1-0.2,0.1-0.3,0.1c-0.1,0-0.1,0.1-0.3,0.1c-0.3,0.1-0.4,0.1-0.6,0.2l-0.2,0.1l-4.7,2.7l0,0 l-0.2,0.1l-0.2,0.2c-0.1,0.1-0.2,0.2-0.5,0.4c-0.2,0.2-0.3,0.2-0.3,0.2c-7.4,4.5-14.3,10.1-22,17.7c-10.2,10.2-19.5,21.3-27.6,33.3 c-15.3,22-28.4,45.4-39,69.9c-4.7,10.7-8.4,21.8-11.2,33.2c-2.7,10.6-4,21.5-3.7,32.4c0.2,8.7,1.9,17.3,5,25.4 c0.4,1.1,0.8,2,1.7,3.9l0,0.1c0.4,0.9,0.6,1.3,0.8,1.8c0,0,0,0.1,0.1,0.1l0,0.1c0.1,0.2,0.1,0.3,0.2,0.5l0.1,0.3l2.4,4.2l0.1,0.2 l0.6,0.7l0.5,0.7c0.4,0.6,0.7,1,1,1.4c4.5,6.3,10,11.8,16.3,16.3c7.5,5.4,15.8,9.8,24.5,13c10.7,4,21.7,6.9,32.9,8.7 c16.4,2.7,33,4.2,49.7,4.3c17.2,0.4,34.3-0.3,51.4-2.2c11.8-1.2,23.5-3.5,35-6.6c8.5-2.3,16.8-5.5,24.7-9.4 c0.3-0.1,0.6-0.2,0.9-0.3c0.4-0.1,0.6-0.2,0.8-0.3l0.3-0.1l5.2-3L789.8,982.7z M781.1,978.9c-0.1,0-0.2,0.1-0.3,0.1 c-0.6,0.2-1.3,0.5-1.9,0.8c-7.4,3.7-15.2,6.7-23.3,8.9c-11.1,3-22.3,5.2-33.7,6.4c-16.7,1.8-33.6,2.5-50.4,2.1 c-16.2-0.2-32.5-1.6-48.5-4.2c-10.8-1.8-21.3-4.6-31.5-8.3c-8.1-3-15.7-7-22.7-12c-5.6-4-10.6-9-14.6-14.6 c-0.3-0.5-0.7-0.9-1.1-1.5l-0.5-0.7l-0.4-0.6l-1.8-3.1l0-0.1c-0.1-0.3-0.2-0.7-0.4-1c-0.2-0.4-0.4-0.9-0.8-1.8l0-0.1 c-0.8-1.8-1.2-2.6-1.5-3.5c-2.8-7.3-4.3-15-4.5-22.8c-0.2-10.2,1-20.5,3.5-30.4c2.7-10.9,6.3-21.6,10.8-32 c10.4-24.1,23.3-47.1,38.3-68.6c7.8-11.5,16.7-22.3,26.6-32.2c7.3-7.2,13.8-12.5,20.6-16.6c0.4-0.3,0.9-0.6,1.2-0.9 c0,0,0,0,0.1-0.1l4-2.3c0,0,0.1,0,0.2-0.1c0.2-0.1,0.3-0.1,0.4-0.2c0.4-0.2,0.9-0.4,1.3-0.6c3.4-1.9,7-3.4,10.7-4.6 c10.8-3.6,22.5-4,33.5-1.1c8.2,2.2,15.9,5.8,22.9,10.5c8.6,5.8,16.6,12.6,23.6,20.2c5.9,6.3,11.4,12.9,16.6,19.8 c4.5,5.9,8.4,11.5,11.8,17c2.2,3.4,3.8,6.1,7.6,12.2c1.6,2.7,2.4,3.9,3.3,5.4c0.2,0.3,0.4,0.6,0.7,0.9c0,0,0,0,0.1,0.1l1.6,2.7 c0,0.1,0.1,0.2,0.1,0.3c0.2,0.5,0.4,0.8,0.5,1.1c4.6,8.2,8.7,15.8,12.2,23.2c4.6,9.5,8.7,19.2,12.2,29.2c3.3,9.3,5.8,19,7.3,28.8 c1.5,8.9,1.6,18,0.4,27c-1.6,12.5-7.1,24.1-15.8,33.2c-3.5,3.6-7.4,6.9-11.5,9.7c-0.5,0.3-1,0.7-1.6,1.2c-0.2,0.1-0.3,0.2-0.6,0.5 c-0.2,0.2-0.4,0.3-0.5,0.4C783.3,977.6,783.1,977.8,781.1,978.9z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  className: "vd1",
  d: "M779.7,1024.1c6.5-4.7,12.2-10.4,16.9-16.9c5.7-8,10.3-16.6,13.7-25.8c4.2-11.4,7.4-23.2,9.4-35.3 c2.9-17.7,4.5-35.7,4.7-53.7c0.4-18.6-0.3-37.2-2.3-55.6c-1.3-12.7-3.7-25.3-7.1-37.6c-2.5-9-5.8-17.8-10-26.2 c-0.3-0.7-0.6-1.5-0.9-2.3l-3-5.1c-0.8-1-1.6-1.9-2.3-2.9c-3.2-4.8-7-9.3-11.2-13.3c-10.8-10.4-23.8-16.3-38.6-18.4 c-10.2-1.3-20.6-1.2-30.7,0.5c-11,1.7-21.8,4.5-32.2,8.2c-11,3.9-21.8,8.4-32.4,13.6c-8.7,4.2-17.2,8.8-25.6,13.5 c-0.5,0.3-1,0.5-1.5,0.7l-3.4,1.9c-0.3,0.2-0.6,0.5-0.9,0.7c-6.4,4-12.9,7.9-19.3,12c-6.4,4.1-12.7,8.5-18.8,13.1 c-7.7,5.7-15.1,11.9-22.1,18.4c-8.6,8-16.2,16.9-22.8,26.6c-5.4,8-9.5,16.9-12.1,26.3c-3.4,12.8-3,26.4,1.2,39 c1.4,4.4,3.2,8.6,5.4,12.5c0.3,0.6,0.5,1.2,0.8,1.8l2.8,4.9c0.3,0.4,0.7,0.8,0.9,1.2c5.2,8.6,11.7,16.2,18.8,23.4 c11,11,22.9,20.9,35.8,29.6c23.8,16.6,49.2,30.7,75.8,42.3c11.5,5,23.4,9.1,35.7,12.1c11.2,2.9,22.8,4.2,34.4,4 c9-0.2,17.9-1.9,26.3-5.2c2.1-0.8,4.2-1.8,6.3-2.8c0.4-0.1,0.7-0.3,1.1-0.4l4-2.3C777.6,1025.6,778.6,1024.8,779.7,1024.1z"
});

var SvgVoluntaryDelivery = function SvgVoluntaryDelivery(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 299.4 313.5",
    style: {
      enableBackground: "new 0 0 299.4 313.5"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2, React.createElement("g", {
    transform: "translate(-525 -723.53)"
  }, React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 580.8304,
    y1: 995.8902,
    x2: 780.0002,
    y2: 791.0644
  }, React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFA700"
    }
  }), React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FAD961"
    }
  }), React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), _ref3, React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 600.7892,
    y1: 991.5443,
    x2: 812.6509,
    y2: 773.6661
  }, React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFA700"
    }
  }), React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FAD961"
    }
  }), React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), _ref4));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgVoluntaryDelivery, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/voluntary-delivery.d60f23ec.svg";
export { ForwardRef as ReactComponent };